
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[projectId]/settings/billing",
      function () {
        return require("private-next-pages/[projectId]/settings/billing.tsx");
      }
    ]);
  